import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { LanguageResponse } from "./data";
import { apiGetLanguageList } from "./service";

export const useGetLanguage = (options: any) => {
  return useQuery<LanguageResponse[]>({
    queryKey: [queryKey.LANGUAGE],
    queryFn: () =>
      apiGetLanguageList().then((res: ApiResponse<LanguageResponse[]>) => {
        return res.data.data;
      }),
    ...options,
  });
};
